import { Pagination } from '@shared/api/abstracts/models';
import { ElasticSearchResponse, Testimony, TestimonyDocument } from '@shared/services/elastic-search/models';

export const testimoniesPaginatedSerializer = (
  testimonies: ElasticSearchResponse<TestimonyDocument>,
  size: number
): Pagination<Testimony> => {
  const items = testimonies.hits.hits.map((testimony) => {
    const source = testimony._source;
    return {
      image: source?.image?.[0] ?? null!,
      url: source?.url?.[0] ?? '',
      author: source?.author?.[0] ?? '',
      text: source?.text?.[0] ?? '',
    };
  });
  return {
    items,
    currentPage: undefined!,
    itemsPerPage: size,
    totalItems: testimonies.hits.total.value ?? 0,
    totalPages: undefined!,
  };
};
